(function () {
  if (window.ucFloatingCartStickyFixLoaded) return;
  window.ucFloatingCartStickyFixLoaded = true;

  var drawerSelector = '#halo-cart-sidebar';
  var bundleSelector = '[data-uc-bc-clean]';
  var bundleButtonSelector = '.uc-bc-clean-add';
  var stickySelector = '[data-uc-sticky-atc-v2]';
  var floatingSelector = '[data-uc-floating-cart]';
  var countTimer = null;
  var stickyFrame = null;
  var mobile = window.matchMedia('(max-width: 989px)');

  function addStyles() {
    if (document.getElementById('uc-floating-cart-sticky-fix-style')) return;
    var style = document.createElement('style');
    style.id = 'uc-floating-cart-sticky-fix-style';
    style.textContent = [
      '.uc-floating-cart{align-items:center;background:#3a2317;border:0;border-radius:999px;bottom:calc(22px + env(safe-area-inset-bottom));box-shadow:0 10px 24px rgba(23,17,13,.22);color:#fffaf2;cursor:pointer;display:flex;height:52px;justify-content:center;position:fixed;right:22px;width:52px;z-index:70}',
      '.uc-floating-cart:focus-visible{outline:2px solid #f1c889;outline-offset:3px}',
      '.uc-floating-cart svg{display:block;height:24px;width:24px}',
      '.uc-floating-cart-count{align-items:center;background:#f1c889;border:2px solid #fffaf2;border-radius:999px;color:#17110d;display:flex;font-size:11px;font-weight:900;height:20px;justify-content:center;line-height:16px;min-width:20px;padding:0 6px;position:absolute;right:-5px;top:-5px}',
      '.uc-floating-cart-count[hidden]{display:none!important}',
      'body.cart-sidebar-show .uc-floating-cart,body.uc-cart-drawer-open .uc-floating-cart,body.drawer-open .uc-floating-cart,body.cart-drawer-open .uc-floating-cart{display:none!important}',
      'body.uc-sticky-atc-visible .uc-floating-cart,body.uc-sticky-atc-v2-visible .uc-floating-cart,body.uc-pistol-sticky-atc-active .uc-floating-cart{bottom:calc(92px + env(safe-area-inset-bottom))}',
      '.uc-sticky-atc-v2.uc-sticky-atc-hotfix-visible{display:grid!important;opacity:1!important;pointer-events:auto!important;transform:translateY(0)!important;visibility:visible!important;z-index:9999!important}',
      '@media (min-width:990px){.uc-sticky-atc-v2{display:none!important}body.uc-sticky-atc-visible,body.uc-sticky-atc-v2-visible{padding-bottom:0!important}body.uc-sticky-atc-visible .uc-floating-cart,body.uc-sticky-atc-v2-visible .uc-floating-cart,body.uc-pistol-sticky-atc-active .uc-floating-cart{bottom:calc(22px + env(safe-area-inset-bottom))!important}}',
      '@media (max-width:768px){.uc-floating-cart{bottom:calc(16px + env(safe-area-inset-bottom));height:50px;right:14px;width:50px}body.uc-sticky-atc-visible .uc-floating-cart,body.uc-sticky-atc-v2-visible .uc-floating-cart,body.uc-pistol-sticky-atc-active .uc-floating-cart{bottom:calc(88px + env(safe-area-inset-bottom))}}'
    ].join('');
    document.head.appendChild(style);
  }

  function rootUrl() {
    var root = window.routes && window.routes.root ? window.routes.root : window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function route(path) {
    return rootUrl() + String(path || '').replace(/^\//, '');
  }

  function isPistolPage() {
    return /\/products\/leather-pistol-case\/?$/i.test(window.location.pathname);
  }

  function isCartOpen() {
    return !!(document.body && document.body.classList.contains('cart-sidebar-show'));
  }

  function syncDrawerState() {
    if (!document.body) return;
    document.body.classList.toggle('uc-cart-drawer-open', isCartOpen());
  }

  function iconSvg() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('d', 'M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm10 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2ZM7.2 14.5h8.9c.8 0 1.5-.4 1.8-1.1L21 6H6.3L5.6 3H2v2h2l3.2 11.5c.2.9 1 1.5 2 1.5H19v-2H9.2l-.4-1.5Z');
    svg.appendChild(path);
    return svg;
  }

  function floatingCartButton() {
    var existing = document.querySelector(floatingSelector);
    if (existing) return existing;
    if (/\/cart\/?$|\/checkout/i.test(window.location.pathname)) return null;
    var button = document.createElement('button');
    var badge = document.createElement('span');
    button.className = 'uc-floating-cart';
    button.type = 'button';
    button.setAttribute('aria-label', 'Open cart');
    button.setAttribute('data-uc-floating-cart', '');
    badge.className = 'uc-floating-cart-count';
    badge.setAttribute('data-uc-floating-cart-count', '');
    badge.hidden = true;
    badge.textContent = '0';
    button.appendChild(iconSvg());
    button.appendChild(badge);
    button.addEventListener('click', openFloatingCart);
    document.body.appendChild(button);
    return button;
  }

  function setFloatingCartCount(count) {
    var button = floatingCartButton();
    if (!button) return;
    var badge = button.querySelector('[data-uc-floating-cart-count]');
    var itemCount = Math.max(0, parseInt(count, 10) || 0);
    if (!badge) return;
    badge.textContent = itemCount > 99 ? '99+' : String(itemCount);
    badge.hidden = itemCount < 1;
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = itemCount;
    });
  }

  function eventCartCount(event) {
    var detail = event && event.detail;
    if (!detail) return null;
    if (detail.item_count !== undefined) return detail.item_count;
    if (detail.cart && detail.cart.item_count !== undefined) return detail.cart.item_count;
    return null;
  }

  function fetchFloatingCartCount() {
    if (typeof window.fetch !== 'function') return Promise.resolve();
    return window.fetch(route('cart.js'), { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (cart && cart.item_count !== undefined) setFloatingCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function scheduleFloatingCartCount(delay) {
    window.clearTimeout(countTimer);
    countTimer = window.setTimeout(fetchFloatingCartCount, delay || 120);
  }

  function dispatchCartOpenEvents() {
    ['cart:open', 'theme:cart:open', 'drawer:open', 'ajaxCart:open', 'uc:cart:open'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      window.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  function openFloatingCart(event) {
    if (event) event.preventDefault();
    scheduleFloatingCartCount(40);
    var result = null;
    var opened = false;
    ['openCartDrawer', 'openCart', 'openSliderCart'].some(function (name) {
      if (typeof window[name] !== 'function') return false;
      opened = true;
      try {
        result = window[name]();
      } catch (error) {
        opened = false;
      }
      return opened;
    });
    if (!opened) {
      if (typeof window.refreshCartDrawer === 'function') {
        Promise.resolve(window.refreshCartDrawer()).catch(function () {});
      }
      dispatchCartOpenEvents();
      window.setTimeout(function () {
        syncDrawerState();
        if (!isCartOpen()) window.location.href = route('cart');
      }, 420);
      return;
    }
    Promise.resolve(result).catch(function () {
      dispatchCartOpenEvents();
    }).then(function () {
      scheduleFloatingCartCount(120);
      syncDrawerState();
    });
  }

  function wrapFetchForCount() {
    if (window.ucFloatingCartCountFetchWrapped || typeof window.fetch !== 'function') return;
    window.ucFloatingCartCountFetchWrapped = true;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var isCartChange = /\/cart\/(add|change|update|clear)(\.js)?/i.test(url);
      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartChange) scheduleFloatingCartCount(180);
        return response;
      });
    };
  }

  function bundleRoot() {
    return document.querySelector(bundleSelector);
  }

  function selectedCard(root) {
    return root && (
      root.querySelector('.uc-bc-clean-card.is-selected, .uc-bc-clean-card.is-active, .uc-bc-clean-card[aria-pressed="true"], .uc-bc-clean-card[aria-selected="true"]') ||
      root.querySelector('.uc-bc-clean-card') ||
      root
    );
  }

  function bundleButton() {
    var root = bundleRoot();
    var card = selectedCard(root);
    return card && card.querySelector(bundleButtonSelector) || root && root.querySelector(bundleButtonSelector);
  }

  function selectedCount() {
    var card = selectedCard(bundleRoot());
    if (!card) return 0;
    var chips = card.querySelectorAll('.uc-bc-clean-chip-name');
    if (chips.length) return chips.length;
    var qtyNode = card.querySelector('.uc-bc-clean-stepper span, .uc-bc-clean-stepper input, [data-uc-bc-qty], [data-quantity]');
    var qty = qtyNode ? parseInt(qtyNode.textContent || qtyNode.value || qtyNode.getAttribute('data-uc-bc-qty') || qtyNode.getAttribute('data-quantity'), 10) : 0;
    return qty > 0 ? qty : 1;
  }

  function stickyBar() {
    var existing = document.querySelector(stickySelector);
    if (existing || !isPistolPage()) return existing;
    var bar = document.createElement('div');
    var copy = document.createElement('div');
    var title = document.createElement('strong');
    var sub = document.createElement('span');
    var edit = document.createElement('button');
    var add = document.createElement('button');
    bar.className = 'uc-sticky-atc-v2';
    bar.setAttribute('data-uc-sticky-atc-v2', '');
    bar.setAttribute('aria-hidden', 'true');
    copy.className = 'uc-sticky-atc-v2__copy';
    title.setAttribute('data-uc-sticky-atc-v2-title', '');
    title.textContent = 'Ready when you are';
    sub.textContent = 'Add selected cases';
    edit.type = 'button';
    edit.className = 'uc-sticky-atc-v2__edit';
    edit.setAttribute('data-uc-sticky-atc-v2-edit', '');
    edit.textContent = 'Edit';
    add.type = 'button';
    add.className = 'uc-sticky-atc-v2__button';
    add.setAttribute('data-uc-sticky-atc-v2-add', '');
    add.textContent = 'Add To Cart';
    copy.appendChild(title);
    copy.appendChild(sub);
    bar.appendChild(copy);
    bar.appendChild(edit);
    bar.appendChild(add);
    document.body.appendChild(bar);
    edit.addEventListener('click', function () {
      var root = bundleRoot();
      if (root) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    add.addEventListener('click', function () {
      var source = bundleButton();
      if (!source) return;
      add.disabled = true;
      add.textContent = 'Adding...';
      source.click();
      window.setTimeout(function () {
        add.disabled = false;
        add.textContent = 'Add To Cart';
        scheduleSticky();
      }, 1400);
    });
    return bar;
  }

  function showStickyBar(bar) {
    bar.setAttribute('data-uc-sticky-wanted', 'true');
    bar.hidden = false;
    bar.removeAttribute('hidden');
    bar.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      if (bar.getAttribute('data-uc-sticky-wanted') !== 'true') return;
      bar.classList.add('is-visible', 'uc-sticky-atc-hotfix-visible');
      if (document.body) document.body.classList.add('uc-sticky-atc-visible', 'uc-sticky-atc-v2-visible');
    });
  }

  function hideStickyBar(bar) {
    bar.setAttribute('data-uc-sticky-wanted', 'false');
    bar.classList.remove('is-visible', 'uc-sticky-atc-hotfix-visible');
    bar.setAttribute('aria-hidden', 'true');
    if (document.body) document.body.classList.remove('uc-sticky-atc-visible', 'uc-sticky-atc-v2-visible');
  }

  function updateSticky() {
    if (!isPistolPage()) return;
    var root = bundleRoot();
    var bar = stickyBar();
    var source = bundleButton();
    if (!bar) return;
    if (!mobile.matches) {
      hideStickyBar(bar);
      return;
    }
    var title = bar.querySelector('[data-uc-sticky-atc-v2-title]');
    var add = bar.querySelector('[data-uc-sticky-atc-v2-add]');
    var count = selectedCount();
    var visible = false;
    if (title) title.textContent = count ? count + (count === 1 ? ' Case Selected' : ' Cases Selected') : 'Ready when you are';
    if (add && add.textContent !== 'Adding...') add.disabled = !source || source.disabled || source.getAttribute('aria-disabled') === 'true';
    if (root && !isCartOpen()) {
      var rootRect = root.getBoundingClientRect();
      var sourceRect = source ? source.getBoundingClientRect() : null;
      if (mobile.matches) {
        visible = window.pageYOffset > 220 || rootRect.top < -40 || rootRect.bottom < 120 || !!(sourceRect && sourceRect.bottom < 120);
      }
    }
    if (visible) showStickyBar(bar);
    else hideStickyBar(bar);
  }

  function scheduleSticky() {
    if (stickyFrame) return;
    stickyFrame = window.requestAnimationFrame(function () {
      stickyFrame = null;
      updateSticky();
    });
  }

  function bindEvents() {
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    ['cart:updated', 'cart:refresh', 'uc:cart:updated', 'uc:cart:refresh', 'ajaxCart:updated', 'cart-update'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        var count = eventCartCount(event);
        if (count !== null) setFloatingCartCount(count);
        else scheduleFloatingCartCount(120);
        syncDrawerState();
        scheduleSticky();
      });
    });
    if (document.body && window.MutationObserver) {
      new MutationObserver(function () {
        syncDrawerState();
        scheduleSticky();
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    var root = bundleRoot();
    if (root && window.MutationObserver) {
      new MutationObserver(scheduleSticky).observe(root, { childList: true, subtree: true, attributes: true });
      ['click', 'change', 'input'].forEach(function (name) {
        root.addEventListener(name, scheduleSticky, true);
      });
    }
  }

  function init() {
    addStyles();
    floatingCartButton();
    wrapFetchForCount();
    scheduleFloatingCartCount(80);
    syncDrawerState();
    scheduleSticky();
    bindEvents();
    window.setTimeout(function () {
      scheduleFloatingCartCount(0);
      syncDrawerState();
      scheduleSticky();
    }, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
